import React, { useReducer } from 'react';
import { Link, withRouter } from 'react-router-dom';
import '../../../assets/bootstrap.css';
// import './VerificationForm2.css';
import './VerificationForm2Timeline.css';
import PlusIcon from '../../../assets/images/plus.svg';
import SuccessIcon from '../../../assets/images/Successfully.svg';
import ErrorIcon from '../../../assets/images/Error.svg';
import { Footer } from '../../navigation/navigation';
import Navbar from '../../navigation/Navbar/Navbar';

// Redux
import { connect } from 'react-redux';

const initialState = {
  title: '',
  description: '',
  location: '',
  amount: '',
  repaymentPeriod: '',
  repaymentTimes: '',
  photoUrl: ''
};

function reducer(state, { field, value }) {
  return {
    ...state,
    [field]: value
  };
}

const VerificationForm2 = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  function onChange(e) {
    dispatch({ field: e.target.name, value: e.target.value });
  }
  const {
    firstName,
    MiddleName,
    bank,
    accountNumber,
    surname,
    bvn,
    loading
  } = state;

  function onSubmit(e) {
    e.preventDefault();

    // const formData = {
    //   firstName,
    //   Bank,
    //   location,
    //   amount,
    //   repaymentPeriod,
    //   repaymentTimes,
    //   photoUrl
    // };
    // // console.log(formData)
    // props.verification2Request(formData);
  }

  // function loader() {
  //     this.setState({ loading : true });

  //     setTimeout(() => {
  //         this.setState({ loading: false })
  //     }, 3000)
  // }

  function closeModal() {
    document.getElementById('message').classList.add('inactive');
    document.getElementById('overlay').classList.add('inactive');
  }

  return (
    <section>
      <Navbar />
      <div className="container col-md-6 mx-auto mb-5">
        <div className="verification-progress-container col-12 col-md-8 mx-auto mt-5 text-center">
          <h4 className="font-weight-bold">Verification</h4>
          <div className="verification-progress mt-4 mt-md-5">
            <div className="verify-item">
              <span className="verify-circle"></span>
            </div>
            <div className="verify-item active">
              <span className="verify-circle active">
                <span className="progress-number">2</span>
              </span>
              <span className="text">Link an Account</span>
            </div>
            <div className="verify-item">
              <span className="verify-circle"></span>
            </div>
            <div className="verify-item">
              <span className="verify-circle"></span>
            </div>
          </div>
        </div>
        <p class="verify-intro-text text-left my-5 col-sm-10 px-0">
          Don't worry your information is private and will not be shared with
          anyone except <Link className="text-fml-secondary">FundMyLaptop</Link>
        </p>

        <form className="needs-validation mt-5 verify-form-bvn" novalidate>
          <div className="form-row">
            <div className="col-md-6 mb-4 pr-md-3">
              <label for="firstName">
                First name <span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="firstName"
                required
              />
              <div className="invalid-feedback">
                Please provide your first name
              </div>
            </div>
            <div className="col-md-6 mb-4 pl-md-3">
              <label for="bank">Bank</label>
              <select className="custom-select" id="bank">
                <option selected disabled value="">
                  Select your bank
                </option>
                <option value="access">Access Bank</option>
                <option value="citibank">Citibank</option>
                <option value="diamond">Diamond Bank</option>
                <option value="ecobank">Ecobank</option>
                <option value="fidelity">Fidelity Bank</option>
                <option value="fcmb">First City Monument Bank (FCMB)</option>
                <option value="fsdh">FSDH Merchant Bank</option>
                <option value="gtb">Guarantee Trust Bank (GTB)</option>
                <option value="heritage">Heritage Bank</option>
                <option value="Keystone">Keystone Bank</option>
                <option value="rand">Rand Merchant Bank</option>
                <option value="skye">Skye Bank</option>
                <option value="stanbic">Stanbic IBTC Bank</option>
                <option value="standard">Standard Chartered Bank</option>
                <option value="sterling">Sterling Bank</option>
                <option value="suntrust">Suntrust Bank</option>
                <option value="union">Union Bank</option>
                <option value="uba">United Bank for Africa (UBA)</option>
                <option value="unity">Unity Bank</option>
                <option value="wema">Wema Bank</option>
                <option value="zenith">Zenith Bank</option>
              </select>
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-6 mb-4 pr-md-3">
              <label for="middleName">
                Middle name <span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="middleName"
                required
              />
              <div className="invalid-feedback">
                Please provide your middle name
              </div>
            </div>
            <div className="col-md-6 mb-4 pl-md-3">
              <label for="accountNumber">Account number</label>
              <input
                type="number"
                className="form-control"
                id="accountNumber"
              />
              <div className="invalid-feedback">
                Please provide a valid account number
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-6 mb-4 pr-md-3">
              <label for="lastName">
                Last name <span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="lastName"
                required
              />
              <div className="invalid-feedback">
                Please provide your last name
              </div>
            </div>
            <div className="col-md-6 mb-4 pl-md-3">
              <label for="BVN">BVN</label>
              <input type="number" className="form-control" id="BVN" />
              <div className="invalid-feedback">Please provide a valid BVN</div>
            </div>
          </div>
          <p className="px-0 py-4">
            Any questions?{' '}
            <Link className="text-fml-secondary">Call Us Now</Link>
          </p>
          <div class="form-buttons d-flex flex-column flex-md-row justify-content-center justify-content-md-end">
            <button
              className="submit btn btn-fml-secondary order-1 order-md-2 align-self-center ml-md-3 mb-3 mb-md-0"
              type="submit"
            >
              Save and Continue
            </button>
            <button className="skip text-dark btn btn-outline-fml-secondary fml-btn-icon order-2 order-md-1 align-self-center">
              Skip
            </button>
          </div>
        </form>
      </div>
      <Footer />
    </section>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
  data: state.data
});

const mapActionsToProps = {};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withRouter(VerificationForm2));
